import { render } from "./dialogEditItem.vue?vue&type=template&id=449c7dec&scoped=true"
import script from "./dialogEditItem.vue?vue&type=script&lang=js"
export * from "./dialogEditItem.vue?vue&type=script&lang=js"

import "./dialogEditItem.vue?vue&type=style&index=0&id=449c7dec&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449c7dec"]])

export default __exports__